import { render } from "./PayslipEditModal.vue?vue&type=template&id=46d5103d"
import script from "./PayslipEditModal.vue?vue&type=script&lang=js"
export * from "./PayslipEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__